import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Spinner from 'react-md-spinner'
import { themeV5 } from 'theme/v5'
import { Box, Typography } from '@mui/material'

const PageLoader = ({ delay, minHeight, color, text = '' }) => {

  const [visible, setVisible] = useState(delay ? false : true)

  useEffect(() => {
    if (delay) {
      setTimeout(() => {
        setVisible(true)
      }, delay)
    }
  }, [delay])

  return (
    <Box
      style={{
        paddingTop: 5,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        ...minHeight
      }}>
      {visible && (
        <Spinner singleColor={color ? color : themeV5.palette.dark} />
      )}
      {text && (
        <Typography
          style={{
            marginLeft: 2,
          }}>{text}</Typography>
      )}
    </Box>
  )
}

PageLoader.propTypes = {
  delay: PropTypes.number,
  minHeight: PropTypes.number,
  color: PropTypes.string,
}

export default PageLoader
